export const RatePlanSurchargeApplicationEnum = Object.freeze({
    BEFORE_MIN_MAX: 'BEFORE_MIN_MAX',
    AFTER_MIN_MAX: 'AFTER_MIN_MAX'
});

export default RatePlanSurchargeApplicationEnum;
